module.exports = __webpack_public_path__ + "static/media/hymnRounded.75a62692.png";